import { useMutation } from 'react-query';
import { AxiosProgressEvent, AxiosResponse } from 'axios';
import { errorToast } from 'components/toasts/error';
import { API } from 'configs/api';
import { useState } from 'react';
import { successToast } from 'components/toasts/success';

export interface IVideoReplyCreateVideo {
  eridEncoded: string;
  shortUrl: string;

  filename: string;
  email: string;
  name?: string;
  message?: string;
}

interface IProgress {
  loaded: number;
  total: number;
  percentage: number;
}

export const videoReplyCreateVideo = async (
  data: IVideoReplyCreateVideo,
  onProgress?: (progress: IProgress) => void
) => {
  const config = {
    onUploadProgress: (progressEvent: AxiosProgressEvent) => {
      if (onProgress) {
        const { loaded, total } = progressEvent;
        const totalSize = total || 0; // Fallback to 0 if total is undefined
        const percentCompleted = Math.round((loaded * 100) / totalSize);
        onProgress({
          loaded: Math.floor(loaded / 1024),
          total: Math.floor(totalSize / 1024),
          percentage: percentCompleted,
        });
      }
    },
  };

  const { eridEncoded, shortUrl, ...rest } = data;
  const response: AxiosResponse<{ message: string }> = await API.post(
    `/video-reply/${shortUrl}/erid/${eridEncoded}/video`,
    rest,
    { ...config }
  );

  return response.data;
};

export const useVideoReplyCreateVideoMutation = () => {
  const [createProgress, setCreateProgress] = useState({
    loaded: 0,
    total: 0,
    percentage: 0,
  });
  return {
    ...useMutation(
      (data: IVideoReplyCreateVideo) =>
        videoReplyCreateVideo(data, setCreateProgress),
      {
        onSuccess: () => {
          successToast({ title: 'Video successfully created!' });
          setTimeout(() => {
            window.close();
          }, 2000);
        },
        onError: () => {
          errorToast({ title: 'Something went wrong while creating video!' });
        },
      }
    ),
    progress: createProgress,
  };
};
